import { render, staticRenderFns } from "./shiftManagementRosterView.vue?vue&type=template&id=806fd464&scoped=true"
import script from "./shiftManagementRosterView.vue?vue&type=script&lang=js"
export * from "./shiftManagementRosterView.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementRosterView.vue?vue&type=style&index=0&id=806fd464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806fd464",
  null
  
)

export default component.exports